import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

export const fetchClients = createAsyncThunk(
  'clients/fetchClients',
  async (
    { page = 1, limit = 8, searchValue = '', sortBy = '', sortOrder = '' } = {},
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState();
      const clubId = state.club?.club?.id;

      if (!clubId) {
        return rejectWithValue(
          'Идентификатор клуба не найден. Пожалуйста, выберите клуб или авторизуйтесь.'
        );
      }

      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (searchValue) {
        params.append('searchValue', searchValue);
      }
      if (sortBy) {
        params.append('sortBy', sortBy);
      }
      if (sortOrder) {
        params.append('sortOrder', sortOrder);
      }

      const response = await api.get(`/clients/${clubId}?${params.toString()}`);
      const { data, pagination } = response.data;

      return { data, pagination };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Ошибка запроса');
    }
  }
);

const initialState = {
  clients: {
    data: [],
    pagination: {
      page: 1,
      limit: 8,
      total: 0,
      totalPages: 1,
    },
  },
  isLoadingClients: false,
  errorClients: null,
};

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    addClient(state, action) {
      // Этот редьюсер уже принимает полный объект и работает корректно
      state.clients.data.unshift(action.payload);
      if (state.clients.pagination?.total != null) {
        state.clients.pagination.total += 1;
      }
    },

    editClient(state, action) {
      // **** ИЗМЕНЕНИЕ ЗДЕСЬ: Обновляем объект клиента целиком ****
      const updatedClient = action.payload; // action.payload теперь должен быть полным обновленным объектом клиента

      const index = state.clients.data.findIndex(
        (c) => c.id === updatedClient.id
      );

      if (index !== -1) {
        // Используем Immer (благодаря Redux Toolkit), поэтому прямая мутация безопасна.
        // Заменяем существующий объект клиента обновленным
        // При этом, если в updatedClient есть поле user, оно будет обновлено.
        // Если поле status есть в updatedClient, оно тоже будет обновлено.
        state.clients.data[index] = {
          ...state.clients.data[index], // Копируем существующие поля (на всякий случай, если в payload чего-то нет)
          ...updatedClient, // Перезаписываем полями из обновленного клиента
          user: {
            // Глубокое обновление для user, чтобы phone и fullName были актуальными
            ...state.clients.data[index].user,
            ...updatedClient.user,
          },
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.isLoadingClients = true;
        state.errorClients = null;
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;

        const updatedData = data.map((client) => {
          const { user } = client;

          return {
            ...client,
            user: {
              ...user,
              fullName: [user?.lastName, user?.firstName]
                .filter(Boolean)
                .join(' '),
            },
          };
        });

        state.clients.data = updatedData;
        state.clients.pagination = pagination;
        state.isLoadingClients = false;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.isLoadingClients = false;
        state.errorClients = action.payload || 'Что-то пошло не так';
      });
  },
});

export const { addClient, editClient } = clientsSlice.actions;

export default clientsSlice.reducer;
